import { Component } from '@angular/core';

@Component({
  selector: 'app-closer-report-deleted-dialog',
  templateUrl: './closer-report-deleted-dialog.component.html',
  styleUrls: ['./closer-report-deleted-dialog.component.scss'],
})
export class CloserReportDeletedDialogComponent {
  includeDeleted = false;
}
